import type { JobPosting } from "@nimble/candidate-api/types";
import {
  type NimbleAtsJobId,
  nimbleAtsJobIdSchema,
} from "@nimble/datamodel/types/nimbleAtsJobId";

export const getNimbleAtsJobId = (
  jobPosting: JobPosting,
): NimbleAtsJobId | null => {
  const parsed = nimbleAtsJobIdSchema.safeParse(jobPosting.ats_job_id);

  if (!parsed.success) {
    return null;
  }

  return parsed.data;
};
